<template>
    <component :is="template">
        <div>
            <v-card tile elevation="0" class="overflow-visible">
                <div>
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">도서 구매내역</h2>
                    </div>

                    <mypage-dashboard-head class="mb-2 mb-md-12" :class="{ 'mt-n7': detect == 'mobile' }" />

                    <div class="mb-4">
                        <shop-purchase-list-filter />
                    </div>

                    <div class="mb-30px mb-md-40px">
                        <shop-purchase-tabs />
                    </div>
                </div>

                <v-tabs-items v-model="tab" touchless>
                    <v-tab-item value="ebook">
                        <shop-purchase-ebuk :isOn="tab == 'ebook'" />
                    </v-tab-item>
                    <v-tab-item value="book">
                        <shop-purchase-book :isOn="tab == 'book'" />
                    </v-tab-item>
                    <v-tab-item value="gift">
                        <shop-purchase-gift :isOn="tab == 'gift'" />
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </div>
    </component>
</template>
<script>
import detect from "@/plugins/detect";

import MypageDashboardHead from "@/components/client/mypage/dashboard/mypage-dashboard-head.vue";
import ShopPurchaseBook from "@/components/client/mypage/shop/shop-purchase-book.vue";
import ShopPurchaseEbuk from "@/components/client/mypage/shop/shop-purchase-ebuk.vue";
import ShopPurchaseGift from "@/components/client/mypage/shop/shop-purchase-gift.vue";
import ShopPurchaseListFilter from "@/components/client/mypage/shop/shop-purchase-list-filter.vue";
import ShopPurchaseTabs from "@/components/client/mypage/shop/shop-purchase-tabs.vue";

export default {
    components: {
        MypageDashboardHead,
        ShopPurchaseBook,
        ShopPurchaseEbuk,
        ShopPurchaseGift,
        ShopPurchaseListFilter,
        ShopPurchaseTabs,
    },
    data: () => ({
        detect,
        tab: "ebook",
    }),
    computed: {
        code() {
            return this.$route.query.code || "ebook";
        },
        template() {
            return () => import(`@/templates/${this.$theme.pages.mypage}`);
        },
        logoff() {
            return !this.$store.state.accessToken;
        },
    },
    created() {
        this.sync();
    },
    watch: {
        code() {
            this.sync();
        },
        logoff() {
            this.sync();
        },
    },
    methods: {
        sync() {
            if (this.logoff) this.$router.push(`/login`);
            if (this.tab != this.code) this.tab = this.code;

            if (this.$route.query.code != this.code) {
                let { ...query } = this.$route.query;
                query.code = this.code;
                this.$router.replace({ query });
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
